/*
GV-Art-Nummer: Hier kann über die Nummer der Art des Geschäftsvorfalls gesucht werden.
3010: Sortenankauf
3020: Sortenverkauf
4010: Edelmetallankauf
4020: Edelmetallverkauf
6010: Reisescheck (historisch)
https://blbintra.prod.blb.de/wiki/display/VERSE/Intra-V+Funktion+Anzeigen
*/
import { Auftragsart } from "rage_api";

const aa = new Auftragsart();

export const GESCHAEFTS_ART = {
  emAK: {
    KEY: aa.emAK,
    CODE: 4010,
    BEZEICHNUNG: "Edelmetall Ankauf"
  },
  emVK: {
    KEY: aa.emVK,
    CODE: 4020,
    BEZEICHNUNG: "Edelmetall Bestellung"
  },
  soAK: {
    KEY: aa.soAK,
    CODE: 3010,
    BEZEICHNUNG: "Sorten Ankauf"
  },
  soVK: {
    KEY: aa.soVK,
    CODE: 3020,
    BEZEICHNUNG: "Sorten Bestellung"
  }
};
